import { Button } from "@fragments";
import { useNavigate } from "react-router-dom";

import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import "./styles.scss";
import { MovieCreationRounded, SlowMotionVideoRounded } from "@mui/icons-material";

import { Text } from "@fragments";

export default function Hero({ info }) {
    const nav = useNavigate();


    function getMetrics() {
        const playlists = info?.content?.length || 0;

        let videos = 0;

        info?.content?.forEach(item => {
            if (item.single) {
                videos += 1;
            } else {
                videos += item.contents?.length || 0;
            }
        });

        return {
            playlists,
            videos,
        }
    }

    const { playlists, videos } = getMetrics();

    return (
        <div className="hero">
            <div className="title-box px-8">
                <Button
                    onClick={() => nav(-1)}
                    color="overlay"
                    size="small"
                    startIcon={<ArrowBackIosNewRoundedIcon />}
                >
                    Voltar
                </Button>

                <Text.h1
                    value={info?.name}
                    className="section-title"
                />

                <Text.h4
                    value={info?.description?.text}
                    className="section-description"
                    maxLines={2}
                />

                <div className="section-metrics mt-2">
                    <div className="section-metric-item">
                        <SlowMotionVideoRounded />
                        <span className="metric-value">{playlists} playlists</span>
                    </div>
                    <div className="section-metric-item">
                        <MovieCreationRounded />
                        <span className="metric-value">{videos} vídeos</span>
                    </div>
                </div>
            </div>
            <Banner src={info?.banner?.wide || info?.banner?.condensed} />

            <span className="banner-hero-shadow"></span>
        </div>
    );
}


function Banner({ src }) {
    return (
        <div className="course-banner-container">
            <img src={src} className="course-banner" />
            <span className="banner-content-left-shadow"></span>
            <span className="banner-content-right-shadow"></span>
            <span className="banner-content-bottom-shadow"></span>
        </div>
    );
}